import { call, put } from 'redux-saga/effects';
import { formatMessage } from 'devextreme/localization';
import * as action from '../actions/finishedProduct';
import { get, post } from '../../utils/api';
import { modalErrorOpen } from '../actions/modalError';

export function* getFinishedProduct({ payload }) {
  try {
    const response = yield call(get, `/grid/production/ready_product/for_confirm/list?plantId=${payload.plantId}&dateFrom=${payload.dateFrom}&dateTo=${payload.dateTo}`);
    yield put(action.getFinishedProductSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.getFinishedProductFail());
  }
}

export function* confirmFinishedProduct({ payload }) {
  try {
    const response = yield call(post, '/production/ready_product/confirm', payload);
    yield put(action.confirmFinishedProductSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.confirmFinishedProductFail());
  }
}

export function* stornoFinishedProduct({ payload }) {
  try {
    const response = yield call(post, `/production/ready_product/storno?comment=${payload.comment}`, payload.readyProductsIds);
    yield put(action.stornoFinishedProductSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.stornoFinishedProductFail());
  }
}

export function* setCancelSendToSap({ payload }) {
  try {
    const response = yield call(post, '/production/ready_product/storno_from_sap', payload.readyProductsIds);
    yield put(action.setCancelSendToSapSuccess(response));
  } catch (error) {
    yield put(
      modalErrorOpen({
        message: error.response.data.message,
        techInfo: error.response.data.techInfo,
        types: 'error',
        title: formatMessage('textError').warning
      })
    );
    yield put(action.setCancelSendToSapFail());
  }
}
